/**
 * Owner Dashboard Guide Component
 * Based on: documentation/cursor/owner-dashboard-ui-specification-v1-final.md
 * Section 4, Component 17: Owner Dashboard Guide
 */

import { useState } from 'react';

export default function OwnerDashboardGuide() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={styles.card}>
      <div style={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <h3 style={styles.title}>Owner Dashboard Guide</h3>
        <span style={{
          ...styles.chevron,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div style={styles.content}>
          <section style={styles.section}>
            <h4 style={styles.sectionTitle}>Calendar</h4>
            <p style={styles.text}>
              The booking calendar shows all reservations for the selected month. Click on any booking to view detailed information.
            </p>
          </section>
          <section style={styles.section}>
            <h4 style={styles.sectionTitle}>Monthly Rental Revenue</h4>
            <p style={styles.text}>
              Revenue is calculated as: <strong>Nightly Rate × Number of Nights - Platform Fees - Cleaning Fees</strong>
            </p>
          </section>
          <section style={styles.section}>
            <h4 style={styles.sectionTitle}>Key Terms</h4>
            <dl style={styles.definitionList}>
              <dt style={styles.term}>Occupancy Rate:</dt>
              <dd style={styles.definition}>Percentage of nights booked out of total available nights</dd>
              <dt style={styles.term}>YoY Growth:</dt>
              <dd style={styles.definition}>Year-over-year revenue growth percentage</dd>
              <dt style={styles.term}>Platform Fee:</dt>
              <dd style={styles.definition}>Fee charged by booking platforms (Airbnb, VRBO, etc.)</dd>
            </dl>
          </section>
        </div>
      )}
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'var(--color-bg-primary)',
    border: '1px solid var(--color-border-light)',
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--spacing-5)',
    boxShadow: 'var(--shadow-md)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  title: {
    fontSize: 'var(--font-size-lg)',
    fontWeight: 'var(--font-weight-semibold)',
    color: 'var(--color-text-primary)',
    margin: 0,
  },
  chevron: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    transition: 'var(--transition-base)',
  },
  content: {
    marginTop: 'var(--spacing-5)',
    paddingTop: 'var(--spacing-5)',
    borderTop: '1px solid var(--color-border-light)',
  },
  section: {
    marginBottom: 'var(--spacing-5)',
  },
  sectionTitle: {
    fontSize: 'var(--font-size-base)',
    fontWeight: 'var(--font-weight-semibold)',
    color: 'var(--color-text-primary)',
    margin: 0,
    marginBottom: 'var(--spacing-2)',
  },
  text: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    lineHeight: 'var(--line-height-relaxed)',
    margin: 0,
  },
  definitionList: {
    margin: 0,
  },
  term: {
    fontSize: 'var(--font-size-sm)',
    fontWeight: 'var(--font-weight-semibold)',
    color: 'var(--color-text-primary)',
    marginTop: 'var(--spacing-2)',
  },
  definition: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    marginLeft: 'var(--spacing-4)',
    marginBottom: 'var(--spacing-2)',
  },
};

